/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../modules/*\/web/route.tsx', { eager: true })
 *
 * Bilan fournisseur négo (mission W-N3, contrat gelé
 * `CONTRACT-BILAN-FOURNISSEUR.md`) — 2 routes top-level supplémentaires
 * `bilans-fournisseurs` (liste) et `bilans-fournisseurs/:idFour` (fiche),
 * `hidden: true` (même pattern que `herbo-lot-detail`/`herbo-commandes` :
 * pas d'onglet TopBar dédié, atteintes via le bouton « Bilans fournisseurs »
 * du bandeau d'en-tête de la page principale du module). Un `export default`
 * en TABLEAU expose les 3 routes top-level.
 */
import { lazy, Suspense, type ReactNode } from 'react';
import type { ModuleRoute } from "@herbo/module-route";

const CommandeLaboTiersPage = lazy(() => import('./pages/CommandeLaboTiers'));
const BilansFournisseursPage = lazy(() => import('./pages/BilansFournisseurs'));
const BilanFournisseurPage = lazy(() => import('./pages/BilanFournisseur'));
const VueFournisseursPage = lazy(() => import('./pages/VueFournisseurs'));

function LoadingFallback(): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      Chargement du module Commande labo tiers…
    </div>
  );
}

const route: ModuleRoute = {
  path: 'commande-labo-tiers',
  label: 'Commande labo tiers',
  icon: 'package',
  element: (
    <Suspense fallback={<LoadingFallback />}>
      <CommandeLaboTiersPage />
    </Suspense>
  ),
};

const bilansListRoute: ModuleRoute = {
  path: 'bilans-fournisseurs',
  label: 'Bilans fournisseurs',
  icon: 'scale',
  hidden: true,
  element: (
    <Suspense
      fallback={
        <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
          Chargement des bilans fournisseurs…
        </div>
      }
    >
      <BilansFournisseursPage />
    </Suspense>
  ),
};

const bilanDetailRoute: ModuleRoute = {
  path: 'bilans-fournisseurs/:idFour',
  label: 'Bilan fournisseur',
  icon: 'scale',
  hidden: true,
  element: (
    <Suspense
      fallback={
        <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
          Chargement du bilan…
        </div>
      }
    >
      <BilanFournisseurPage />
    </Suspense>
  ),
};

const vueFournisseursRoute: ModuleRoute = {
  path: 'vue-fournisseurs',
  label: 'Fournisseurs',
  icon: 'pie-chart',
  // MASQUÉ de la TopBar depuis le 22/08 (Ben : « regroupe toutes les infos
  // sous onglet Fournisseurs ») : l'entrée de nav unique est celle du module
  // herbo-fournisseurs (/fournisseurs), qui porte des onglets locaux
  // « Fiches | CA & marges » naviguant vers cette page — la route reste
  // parfaitement atteignable, seul l'onglet TopBar en double disparaît.
  // (Historique : onglet VISIBLE demandé Ben 26/07, remplacé par ce
  // regroupement.)
  hidden: true,
  element: (
    <Suspense
      fallback={
        <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
          Chargement de la vue fournisseurs…
        </div>
      }
    >
      <VueFournisseursPage />
    </Suspense>
  ),
};

export default [route, bilansListRoute, bilanDetailRoute, vueFournisseursRoute];
